import { Box, Typography, useTheme } from '@mui/material'
import { FolderOpen } from '@phosphor-icons/react'
import { FormattedMessage } from 'react-intl'

const Header = () => {
  const theme = useTheme()
  return (
    <Box display="flex" gap={theme.spacing(1)} alignItems="center" pl={theme.spacing(1)} pb={theme.spacing(1)}>
      <FolderOpen size={16} weight="bold" color={theme.colours.new.grey2} />
      <Typography
        fontSize={theme.typography.pxToRem(12)}
        color={theme.colours.new.grey2}
        fontWeight={theme.typography.fontWeightBold}
        textTransform="uppercase"
      >
        <FormattedMessage id="cases.recentlyViewedCases" />
      </Typography>
    </Box>
  )
}

export default Header
